export default async ({ store }) => {
	if (!store.state.settings._uid) {
		await store.dispatch('loadSettings');
	}
}